import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const MosaicCardMask = styled.div<React.CSSProperties>`
  background: linear-gradient(
    270deg,
    rgba(0, 0, 0, 0.8) 33.41%,
    rgba(0, 0, 0, 0) 93.32%
  );
  border-radius: ${20 * Screen.widthRatio}px;
  height: ${197 * Screen.widthRatio}px;
  left: ${118 * Screen.widthRatio}px;
  position: absolute;
  width: ${232 * Screen.widthRatio}px;
`;

export default MosaicCardMask;
